<template>
  <div class="f-regulationsModal">
    <b-modal id="regulationsModal"
             ref="regulationsModal"
             centered
             no-footer
             size="lg"
             title='Contest "Alpine Food Heritage Stories"'>
      <template v-for="(sect, index) in activeLanguage.regulationsItems">
        <h3 :key="index">{{sect.title}}</h3>
        <p v-html="sect.content"></p>
      </template>

      <div slot="modal-footer" class="w-100">
        <b-button class="button-style float-right" @click="hideModal">{{activeLanguage.close}}</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: 'RegulationsModal',
    computed: {
      activeLanguage () {
        let currLang = this.$translations[this.$store.getters.currentLanguageValue]
        if (currLang.regulationsItems) {
          return this.$translations[this.$store.getters.currentLanguageValue]
        } else {
          return this.$translations['Italian']
        }
      }
    },
    methods: {
      showModal () {
        this.$refs.regulationsModal.show()
      },
      hideModal () {
        this.$refs.regulationsModal.hide()
      }
    },
    mounted () {
      document.getElementById('regulationsModal___BV_modal_header_').setAttribute('style', 'background-color: #c41c21 !important; color: white !important;')
      document.getElementById('regulationsModal___BV_modal_header_').lastChild.setAttribute('style', 'color: white !important;')
    }
  }
</script>

<style scoped>

  h3 {
    text-align: left;
    color: #c41c21;
  }

  p {
    text-align: left;
  }

  .button-style {
    background-color: grey !important;
    border-color: grey !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/contestPageComponents/RegulationsModal.vue